import { Modal } from '@/components/common/AppModal';
import McpChatOnboarding from './McpChatOnboarding';
import { useMcpChatOnboarding } from '../../hooks/McpChatOnboardingContext';

const McpChatOnboardingModal = () => {
  const { gate, modalOpen, needsOnboarding, dismissOnboarding } =
    useMcpChatOnboarding();

  if (!needsOnboarding) {
    return null;
  }

  return (
    <Modal
      show={modalOpen}
      onHide={dismissOnboarding}
      size="lg"
      scrollable
      centered
    >
      <Modal.Header closeButton className="py-2 px-3 border-bottom">
        <Modal.Title className="fs-0 mb-0">راه‌اندازی چت AI</Modal.Title>
      </Modal.Header>
      <Modal.Body className="py-3 px-3">
        <McpChatOnboarding
          gate={gate}
          variant="modal"
          onEnterChatNavigate={false}
        />
      </Modal.Body>
    </Modal>
  );
};

export default McpChatOnboardingModal;
